import { render } from "./AddNote.vue?vue&type=template&id=6c505782&scoped=true&ts=true"
import script from "./AddNote.vue?vue&type=script&lang=ts"
export * from "./AddNote.vue?vue&type=script&lang=ts"

import "./AddNote.vue?vue&type=style&index=0&id=6c505782&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c505782"]])

export default __exports__